import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { useAuth } from './AuthContext';
import { processAllData } from '../utils/dataParser';
import seedData from '../data/rawSheetsData.json';
import { useSelector } from 'react-redux';
import * as XLSX from "xlsx";
import { useSearchParams } from "react-router-dom";
import { LoadContext } from '../../../../ReusableComponents/LoadingContex';
const DataContext = createContext(null);

// export const MASTER_LINKS = {
//   // Madhapur: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQqXSLBtPhZstn2laNO5WUJ-uCf_XfwwGmxJTVPEeE6etR1DjV2vhFOT-SwKsBrwg/pub?gid=1866643859&single=true&output=csv",
//   // "Vasant Nagar": "https://docs.google.com/spreadsheets/d/e/2PACX-1vQqXSLBtPhZstn2laNO5WUJ-uCf_XfwwGmxJTVPEeE6etR1DjV2vhFOT-SwKsBrwg/pub?gid=378564856&single=true&output=csv",
//   // Kokapet: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQqXSLBtPhZstn2laNO5WUJ-uCf_XfwwGmxJTVPEeE6etR1DjV2vhFOT-SwKsBrwg/pub?gid=2069114240&single=true&output=csv",
//   // KPHB: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQqXSLBtPhZstn2laNO5WUJ-uCf_XfwwGmxJTVPEeE6etR1DjV2vhFOT-SwKsBrwg/pub?gid=421285242&single=true&output=csv"
//   // KPHB : "https://docs.google.com/spreadsheets/d/1Sp0ZnHRnsHze4becml9eoJTkbztMkGe2-Vt8fSupNnM/pub?gid=950223893#gid=950223893"
//   // Safdaria: "https://docs.google.com/spreadsheets/d/1Sp0ZnHRnsHze4becml9eoJTkbztMkGe2-Vt8fSupNnM/export?format=csv&gid=950223893&single=true&output=csv",
//   // Milly: "https://docs.google.com/spreadsheets/d/170Yk64GqTj1SpYuENO_Co8QoEu_ArxjEr7INyC11Zoo/export?format=csv&gid=431478009&single=true&output=csv"
// };
// export const FetchSchools = [...new Set(Object.keys(MASTER_LINKS))];
// localStorage.setItem("ASchools", JSON.stringify(FetchSchools));

// export const RESPONSE_LINKS = {
//   // grade6_math:    { url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vS6_DSrJefFP6g8dI71PAlMcTUpz8UaILfKrPFS7aWDuMnQVYqaddn9tldyo4o9UA/pub?gid=347721240&single=true&output=csv",    subject: "Math" },
//   // grade6_english: { url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vS6_DSrJefFP6g8dI71PAlMcTUpz8UaILfKrPFS7aWDuMnQVYqaddn9tldyo4o9UA/pub?gid=1056508226&single=true&output=csv", subject: "English" },
//   // grade4_math:    { url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTNcSHyd4TH_sjb8gozYmdVbmid1dp65BbTyCJe_WGIIB325uHpOazN2bJNJot3lw/pub?gid=1062972701&single=true&output=csv", subject: "Math" },
//   // grade4_english: { url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTNcSHyd4TH_sjb8gozYmdVbmid1dp65BbTyCJe_WGIIB325uHpOazN2bJNJot3lw/pub?gid=1986900834&single=true&output=csv", subject: "English" }
//   //  Millit

//   grade3_english: { url: "https://docs.google.com/spreadsheets/d/1cwKhewJqBjkSo_wcNETKk1jV01U8QXqWpxsd-GqWWok/export?format=csv&gid=1612241282&single=true&output=csv", subject: "English" },
//   grade3_math: { url: "https://docs.google.com/spreadsheets/d/1G_bTG72HEyM6XjMvNIWve2s2G5J9GDj5vYRAR6IKkFo/export?format=csv&gid=689507843&single=true&output=csv", subject: "Math" },
//   grade4_english: { url: "https://docs.google.com/spreadsheets/d/1R1pWeFHWWZYTO4glRTpavUdl5D1KA6nTwrZQbBU2aPw/export?format=csv&gid=1798473559&single=true&output=csv", subject: "English" },
//   grade3_math: { url: "https://docs.google.com/spreadsheets/d/1f2CUh1QSdHcDeIUbukwmbOKpKPg5j0sZQMOtFusoKVo/export?format=csv&gid=655277194&single=true&output=csv", subject: "Math" },

//   //  SAFDARIA
//   grade5_english: { url: "https://docs.google.com/spreadsheets/d/1fOoAcH6OSDzaJxX7-2Ywp_oI8g58zq1i/export?format=csv&gid=1885668899&single=true&output=csv", subject: "English" },
//   grade5_math: { url: "https://docs.google.com/spreadsheets/d/1GU-DxWDzaj43wIu9fyZlo-9BNMyvbuYg/export?format=csv&gid=1806500452&single=true&output=csv", subject: "Math" },

// };
// export const FetchGrades = [
//   ...new Set( Object.keys(RESPONSE_LINKS) .map(key => parseInt(key.split("_")[0].slice(-1), 10))  )
// ];
// localStorage.setItem("AGrades", JSON.stringify(FetchGrades));

export const DataProvider = ({ children }) => {
  const { branchLock } = useAuth();
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);
  const [syncStatus, setSyncStatus] = useState('idle'); // 'idle' | 'syncing' | 'success' | 'failed'
  const [lastSyncTime, setLastSyncTime] = useState('');
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
  const {SetLoad} = useContext(LoadContext);

const SchoolData = JSON.parse(localStorage.getItem("SDetails"));
  // Scoping filters
  const [currentBranchFilter, setCurrentBranchFilter] = useState('all');
  const [activeTab, setActiveTab] = useState('participation');

  // Parsed dataset structures
  const [dataset, setDataset] = useState({
    allStudentsData: [],
    schoolInfo: new Map(),
    loMap: new Map(),
    levelMap: new Map(),
    mathResults: new Map(),
    englishResults: new Map(),
    masterList: new Map()
  });
  // Pre-seed data on startup
  useEffect(() => {
    // try {
    //   const result = processAllData(seedData);
    //   setDataset(result);
    //   setLastSyncTime(new Date().toLocaleTimeString());
    //   setSyncStatus('success');
    // } catch (e) {
    //   console.error("Failed to seed local spreadsheet logs", e);
    //   setSyncStatus('failed');
    // } 
    // finally { setLoading(false); }
    // syncWithGoogleSheets();
    if (!SelectDate || !USYear || !items || SelectDate?.assessmentType !== 3) {
      return;
    }
    syncWithGoogleSheets();
  }, [SelectDate, USYear, items]);
  // , grades || grades.length === 0
  // Update branch filter if user profile locks it

  useEffect(() => {
    // if (branchLock) { setCurrentBranchFilter(branchLock); } 
    setCurrentBranchFilter(items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue);
    // else { setCurrentBranchFilter('all'); }
  }, [branchLock]);

  // Scoped student fetch
  const getScopedStudents = () => {
    let list = dataset.allStudentsData;
    if (branchLock) { return list.filter(s => s.school === branchLock); }
    if (currentBranchFilter === 'all') { return list; }
    return list.filter(s => s.school === currentBranchFilter);
  };

  // Live synchronizer from Google Sheets endpoints
  const syncWithGoogleSheets = async () => {
    if (syncing) return;
    SetLoad(true);
    setSyncing(true);
    setSyncStatus('syncing');

    const fetchText = async (url) => {
      // Add a random query parameter to bypass cache
      const response = await fetch(`${url}&_cb=${Date.now()}`, { cache: 'no-store' });
      if (!response.ok) throw new Error(`HTTP ${response.status} fetching ${url}`);
      return await response.text();
    };
    try {
      // const responseEntries = Object.entries(RESPONSE_LINKS);
      // const masterEntries = Object.entries(MASTER_LINKS);

      // Fetch all CSV exports in parallel

      // const responseTexts = await Promise.all(responseEntries.map(([, cfg]) => fetchText(cfg.url)));
      // const masterTexts = await Promise.all(masterEntries.map(([, url]) => fetchText(url)));

      const freshRawData = await processAllFiles();
      // processFiles();
      // responseEntries.forEach(([key], i) => { freshRawData[`response_${key}`] = responseTexts[i]; });
      // masterEntries.forEach(([schoolKey], i) => { freshRawData[`master_${schoolKey}`] = masterTexts[i]; });

      // Map and process details
      const result = processAllData(freshRawData, items,SchoolData);
      setDataset(result);
      setLastSyncTime(new Date().toLocaleTimeString());
      setSyncStatus('success');
    } catch (e) {
      console.error("Could not sync with live spreadsheet. Relying on pre-seeded backup data.", e);
      setSyncStatus('failed');
    } finally {
      setSyncing(false);
        SetLoad(false);
    }
  };
  // const masterFiles = [`/Registrations/${items?.schoolName?.trim()} - Student Logins for NSF.xlsx`,];
  // const masterFiles = [`/Registrations/${items?.schoolName?.trim()} - Student Logins for NSF.xlsx`,];

  const masterFiles = useMemo(() => {

    // Don't create file paths before SelectDate is available
    if (!SelectDate || !USYear || !items) { return []; }
    // if (items?.userTypeId === 2) {
      if (items.instituteId === 1 || items.instituteId === 3) {
        return [`/ExportStudents/${USYear.display}/${SelectDate.display}/Registrations/${SelectDate.display}_${items.instituteCode}_{SRSData?.display}_${SelectDate.examStartDate}_${items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue}.xlsx`]

      } else if (items.instituteId === 8 || items.instituteId === 9 || items.instituteId === 5) {
        // return [`/ExportStudents/${USYear.display}/${SelectDate.display}/Registrations/${SelectDate.display}_SSSO_${SelectDate.examStartDate}_${items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue}.xlsx`]
        return [`/ExportStudents/${USYear.display}/${SelectDate.display}/Registrations/${SelectDate.display}_${items?.userTypeId === 2 ? items.societyName: items?.societyCode}_${SelectDate.examStartDate}_${items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue}.xlsx`]

      } else {
        return [`/ExportStudents/${USYear.display}/${SelectDate.display}/Registrations/${SelectDate.display}_${items.instituteCode}_${SelectDate.examStartDate}_${items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue}.xlsx`]
      }
  }, [SelectDate, USYear, items]);

  

  const processMasterFiles = async () => {
    const output = {};
    for (const filePath of masterFiles) {
      try {
        const response = await fetch(filePath);
        if (!response.ok) {
          throw new Error(`Unable to load master file: ${filePath}`);
        }
        const buffer = await response.arrayBuffer();
        const workbook = XLSX.read(buffer, { type: "array", });
        workbook.SheetNames.forEach((sheetName) => {
          const sheet = workbook.Sheets[sheetName];
          const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "", });
          if (!rows.length) { return; }
          /* Find the actual master header
           *SNo, StudentId, Student Name, Gender, Date of Birth, Grade, Section, ...
           */
          const headerIndex = rows.findIndex((row) => {
            const normalizedRow = row.map((value) => String(value ?? "").trim().toLowerCase());
            return (
              normalizedRow.includes("sno") && normalizedRow.includes("studentid") &&
              normalizedRow.includes("student name") && normalizedRow.includes("grade")
            );
          });

          if (headerIndex === -1) {
            return;
          }
          /* Get header */
          const header = rows[headerIndex];
          /* Find required columns */
          const studentIdIndex = header.findIndex((value) => String(value ?? "").trim().toLowerCase() === "studentid");
          const studentNameIndex = header.findIndex((value) => String(value ?? "").trim().toLowerCase() === "student name");
          const gradeIndex = header.findIndex((value) => String(value ?? "").trim().toLowerCase() === "grade");
          /* Validate columns */
          if (studentIdIndex === -1 || studentNameIndex === -1 || gradeIndex === -1) {
            return;
          }
          /* Get student rows */
          const studentRows = rows.slice(headerIndex + 1).filter((row) => {
            const studentId = String(row[studentIdIndex] ?? "").trim();
            return studentId !== "";
          });

          if (!studentRows.length) {
            return;
          }
          /* Get school name
           * First row normally contains: SCHOOL NAME - Student Logins for NSF */
          let schoolName = "";
          const firstRowValue = String(rows[0]?.[0] ?? "").trim();
          if (firstRowValue) {
            schoolName = firstRowValue.replace(/\s*-\s*Student Logins for NSF\s*$/i, "").trim();
          }
          /* If school name couldn't be obtained,use sheet name.*/
          if (!schoolName) { schoolName = sheetName; }
          /* Create master key
           * Example:master_SRI SATHYA SAI VIDYA MANDIR DHARWAD */
          const key = `master_${schoolName}`;
          /* Convert original sheet to CSV */
          const csvData = XLSX.utils.sheet_to_csv(sheet);
          output[key] = csvData;
        });
      } catch (error) { console.error( "Error processing master file:", filePath, error ); }
    }
    return output;
  };

  const grades = useMemo(() => {
    if (!SelectDate) { return []; }
    return [
      ...new Set([...(SelectDate.grades_1_10 ? SelectDate.grades_1_10.split(",").map(Number) : []),
      ...(SelectDate.grades_11_12 ? SelectDate.grades_11_12.split(",").map(Number) : [])
      ])
    ]
    // .sort((a, b) => a - b);
  }, [SelectDate]);
localStorage.setItem("AGrades", JSON.stringify(grades));

  const excelFiles = useMemo(() => {

    // Don't create file paths before SelectDate is available
    if (!SelectDate || !USYear || !items || grades.length === 0) { return []; }

    if (items.instituteId === 1 || items.instituteId === 3) {
      return grades.map((G) =>
        `/ExportStudents/${USYear.display}/${SelectDate.display}/${SelectDate.display}_${items.instituteCode}_{SRSData?.display}_${G}_${SelectDate.examStartDate}.xlsx`
      );

    } else if (items.instituteId === 8 || items.instituteId === 9 || items.instituteId === 5) {
      return grades.map((G) =>
        `/ExportStudents/${USYear.display}/${SelectDate.display}/${SelectDate.display}_${items?.userTypeId === 2 ? items.societyName?.replace("-", "") : items?.societyCode?.replace("-", "")}_${G}_${SelectDate.examStartDate}.xlsx`
        // `/ExportStudents/${USYear.display}/${SelectDate.display}/${SelectDate.display}_SSSO_${G}_${SelectDate.examStartDate}.xlsx`
      );

    } else {
      return grades.map((G) =>
        `/ExportStudents/${USYear.display}/${SelectDate.display}/${SelectDate.display}_${items.instituteCode}_${G}_${SelectDate.examStartDate}.xlsx`
      );
    }
  }, [SelectDate, USYear, items, grades]);

  const processFiles = async () => {
    const output = {};

    for (const filePath of excelFiles) {
      try {
        const response = await fetch(filePath);
        if (!response.ok) {
          throw new Error(`Unable to load ${filePath}`);
        }
        const buffer = await response.arrayBuffer();
        const workbook = XLSX.read(buffer, { type: "array", });
        /* Process every sheet in the workbook */
        workbook.SheetNames.forEach((sheetName) => {
          const sheet = workbook.Sheets[sheetName];

          /* -----------------------------------------
           * Get Grade and Subject from sheet name
           * -----------------------------------------
           */

          const lowerSheetName = sheetName.toLowerCase();
          let grade = "";
          let subject = "";
          /* Find grade
           * Supports:
           * Grade 3
           * Grade3
           * grade_3
           * grade-3 */

          const gradeMatch = lowerSheetName.match(/grade[\s_-]*(\d+)/);
          if (gradeMatch) { grade = gradeMatch[1]; }
          /* Find subject */
          if (lowerSheetName.includes("english")) {
            subject = "english";
          } else if (lowerSheetName.includes("math") || lowerSheetName.includes("maths") || lowerSheetName.includes("mathematics")) {
            subject = "math";
          }
          /*If grade or subject cannot be found, skip this sheet. */

          if (!grade || !subject) {
            // console.warn( "Grade or subject not found:", sheetName );
            return;
          }
          /*
           * -----------------------------------------
           * Convert sheet to CSV
           * -----------------------------------------
           */
          const csvData = XLSX.utils.sheet_to_csv(sheet);
          // XLSX.utils.sheet_to_csv(filteredSheet);
          /*
           * -----------------------------------------
           * Create final key
           * -----------------------------------------
           * Example: response_grade3_english, response_grade3_math
           * response_grade4_english, response_grade4_math
           */
          const key = `response_grade${grade}_${subject}`;
          /* Store CSV data */
          output[key] = csvData;
        });
      } catch (error) {
        console.error("Error processing file:", filePath, error);
      }
    }
    /*
     * -----------------------------------------
     * Final result
     * -----------------------------------------
     */
    return (output);
  };

  const processAllFiles = async () => {
    const responseData = await processFiles();
    const masterData = await processMasterFiles();
    const finalData = { ...responseData, ...masterData, };
    return (finalData);
  };
  // Multi-school / custom data seed injector (for Deliv 1 - Super Admin onboarding second school)
  // const injectFictionalSchoolData = (schoolName, rosterCSV, englishCSV, mathCSV) => {
  //   // A mock onboarding processor
  //   try {
  //     // In practice this allows super admins to register fictional tenant school datasets dynamically.
  //     const freshRaw = { ...seedData };
  //     freshRaw[`master_${schoolName}`] = rosterCSV;
  //     freshRaw[`response_grade5_math`] += "\n" + mathCSV;
  //     freshRaw[`response_grade5_english`] += "\n" + englishCSV;

  //     const result = processAllData(freshRaw);
  //     // console.log("freshRawData",freshRawData)
  //     setDataset(result);
  //     setLastSyncTime(new Date().toLocaleTimeString());
  //     setSyncStatus('success');
  //     return true;
  //   } catch (error) {
  //     console.error("Failed to onboard new fictional branch data", error);
  //     return false;
  //   }
  // };

  return (
    <DataContext.Provider value={{
      loading,
      syncing,
      syncStatus,
      lastSyncTime,
      currentBranchFilter,
      setCurrentBranchFilter,
      activeTab,
      setActiveTab,
      allStudentsData: dataset.allStudentsData,
      schoolInfo: dataset.schoolInfo,
      loMap: dataset.loMap,
      levelMap: dataset.levelMap,
      mathResults: dataset.mathResults,
      englishResults: dataset.englishResults,
      getScopedStudents,
      syncWithGoogleSheets,
      // injectFictionalSchoolData
    }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
